import { printAxios } from './printAxios'
import { toDomainHttpClient } from './toDomainHttpClient'

// 인쇄 트래킹(printApiTrack)이 쿼리 파라미터의 mp_event_name 을 읽는다.
export const domainPrintHttpClient = toDomainHttpClient(printAxios, { forwardMeta: true })
